<template>
<div>
   <br>
<div>
  <v-card
    class="mx-auto"
  >
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline">{{objMensagem.descricao}}</v-list-item-title>
        <v-list-item-subtitle>Janela de Leitura de mensagem</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-btn fab small color="primary" @click="$router.push('MensagensRecebidas')" style="margin-top:-120px;">
         <v-icon>arrow_back</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
         <v-col md="3">
            <span>De:</span><v-chip>{{objMensagem.from}}</v-chip><br>
            para mim.
         </v-col>
         <v-col md="12">
           <div style="border:1px solid #ccc;">
             <h3 style="text-align:center;">{{objMensagem.titulo}}</h3>
             <p style="width:650px;margin-left:400px;">{{objMensagem.corpo}}</p>
           </div>
         </v-col>
      </v-row>
    </v-card-text>

  </v-card>
</div>
</div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    item: 1,
    mensagens: [],
    objMensagem: ls.get('mensagem')
  }),
  created () {
    this.TornaLida(this.objMensagem.pkMensagem)
    this.InitializeMensagens()
  },
  methods: {
    async InitializeMensagens () {
      try {
        let mensagens = await axios
          .get('/mensagemFindAll')
          .then(res => res.data)
        ls.set('mensagensDefault', mensagens)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async  TornaLida (pkMensagemP) {
      let params = {
        pkMensagem: pkMensagemP
      }
      try {
        this.mensagens = await axios
          .post('/tornarLida', params)
          .then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }
  }
}
</script>
<style scoped>

</style>
